import { render, staticRenderFns } from "./schoolfour.vue?vue&type=template&id=728289a0&scoped=true"
import script from "./schoolfour.vue?vue&type=script&lang=js"
export * from "./schoolfour.vue?vue&type=script&lang=js"
import style0 from "./schoolfour.vue?vue&type=style&index=0&id=728289a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728289a0",
  null
  
)

export default component.exports